import React from "react";
import AllRecallStore from "../AllRecallStore";
import { observer, inject } from "mobx-react";
import ArrowCollapsible from "../../ArrowCollapsible";
import PlusCollapsible from "../../PlusCollapsible";

export interface CurrentRecallProps {}

interface InjectedProps extends CurrentRecallProps {
  allRecallStore: AllRecallStore;
}

const currentRecalls: React.SFC<CurrentRecallProps> = (props) => {
  const { allRecallStore } = props as InjectedProps;
  const response = allRecallStore.currentRecalls?.response;

  return (
    <ArrowCollapsible id={"currentRecalls"} title={"Current Recalls"} isCollapsed={false}>
      {
        <div>
          {response && response.length > 0 && response.map((item, i) => {
            return (
              <div key={`${item.id}`}>
                <PlusCollapsible id={item.id} title={item.title} isCollapsed={true}>
                  <div dangerouslySetInnerHTML={{ __html: item.description }} />
                </PlusCollapsible>
              </div>
            );
          })}
        </div>
      }
    </ArrowCollapsible>
  );
};

export default inject("allRecallStore")(observer(currentRecalls));
